/**
 * TYT Platform API
 * This is the TYT Platform API. It is used by TYT's apps to interact 
 * with the underlying platform. 
 *
 * NOTE: This file is auto generated. 
 * Do not edit this file manually.
 */

import { BaseModel, Expand, Model, Type } from '../../common';


export interface UserExternalRequest {

    /**
     * User or Guest
     */
    type?: string;

    /**
     * User ID
     */
    id?: number;

    /**
     * User's email address
     */
    email?: string;

    uuid?: string;

    /**
     * Username for the user
     */
    username?: string;

    display_name?: string;

    admin?: string;

    /**
     * True if a user is a staff member
     */
    staff?: boolean;

    super_admin?: string;

    member?: boolean;

}

@Model('UserExternal')
export class ApiUserExternal extends BaseModel implements UserExternalRequest {

    /**
     * User or Guest
     */
    
    
    type: string;

    /**
     * User ID
     */
    
    
    id: number;

    /**
     * User's email address
     */
    
    
    email: string;

    
    
    uuid: string;

    /**
     * Username for the user
     */
    
    
    username: string;

    
    
    display_name: string;

    
    
    admin: string;

    /**
     * True if a user is a staff member
     */
    
    
    staff: boolean;

    
    
    super_admin: string;

    
    
    member: boolean;

}
